import { Component, ComponentInterface, h, Prop } from '@stencil/core';

@Component({
  tag: 'av-spinner',
  styleUrl: 'av-spinner.scss',
  shadow: true,
})
export class AvSpinner implements ComponentInterface {

  @Prop() dark: boolean;
  @Prop() isTray: boolean;

  render() {
    return (
      <div class={{ 'av-spinner': true, 'av-spinner-dark': this.dark, 'av-spinner-tray': this.isTray }}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  }

}
